import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResponse } from '../../models/base/base-response.dto';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { PaymentsApiRequestDto } from '../../models/payments/payments-api-request.dto';
import { PaymentsApiResponseDto } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PaymentsApiService {
  constructor(private http: HttpClient) {}

  public createPayment(input: PaymentsApiRequestDto): Observable<PaymentsApiResponseDto> {
    return this.http
      .post<BaseResponse<PaymentsApiResponseDto>>(`${environment.serverUrl}/payment/payment/createPayment`, input)
      .pipe(map((p) => p.result));
  }
}